import * as React from "react";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import {
    LOGIN_PROVIDER_AUTO_FIRSTCARE, LOGIN_PROVIDER_AUTO_AAL, AALinkModalExpire, LinkModalExpire,
    LOGIN_PROVIDER_AUTO_HR_SWHP, LOGIN_PROVIDER_AUTO_SWHP
} from "../../constants/textConstants";
import Cookies from "cookies-js";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import * as d from "../../reducers/domainReducer";
import { getFirstName } from "../../helpers/formatting";
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import MiniSpinner from '../common/MiniSpinner';

class AutoLinkModalForHP extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            linkSuccess: false,
            linkLater: false
        };
        this.toggleModal = this.toggleModal.bind(this);
        this.onLinkAccount = this.onLinkAccount.bind(this);
        this.currentUserRole = '';
    }

    onLinkAccount(confirm) {
        const { LoginProvider, ProviderKey } = this.props.currentHealthPlanInfo;
        if (confirm === 'yes') {
            logUI("MBHWeb.UI.AutoLinkForHP.Clicked.Yes", new Date(), Tools.getURLPath(), JSON.stringify({ "LoginProvider": LoginProvider }));
            this.props.linkAutoAccount(LoginProvider, ProviderKey, this.currentUserRole);
            this.setState({ linkSuccess: true });
        }
        else {
            logUI("MBHWeb.UI.AutoLinkForHP.Clicked.No", new Date(), Tools.getURLPath(), JSON.stringify({ "LoginProvider": LoginProvider }));
            this.setState({ linkLater: true });
        }
    }

    toggleModal(isSetExpire) {
        const { userName, serverData } = this.props;
        const { LoginProvider } = this.props.currentHealthPlanInfo;
        const modalExpireKey = this.currentUserRole === 'AA' ? AALinkModalExpire : "_" + LoginProvider + "_" + LinkModalExpire;
        if (isSetExpire) {
            const aaLinkingModalExpireInDays = serverData ? serverData.aaLinkingModalExpireInDays : 15;
            //const expiration = new Date(new Date().getTime() + (1000 * 60 * 1));  // 1 min to test.
            const expiration = new Date(new Date().getTime() + parseInt(aaLinkingModalExpireInDays) * 1000 * 60 * 60 * 24);
            Cookies.set(userName + modalExpireKey, true, { path: '/', 'expires': expiration });
        }
        this.props.hideAutoHPLinkModal(false);
    }

    getHealthPlanName(currentUserRole) {
        switch (currentUserRole) {
            case "AA":
                return "BSWQA-DFW ConnectedCare";
            case "SWHP":
                return "Baylor Scott & White Health Plan";
            case "FC":
                return "FirstCare Health Plans";
            default:
                return "";
        }
    }

    render() {
        const { showModal, linkAutoError, isAutoLinking, linkAutoSuccess, primaryUser, currentHealthPlanInfo } = this.props;
        const { linkSuccess, linkLater } = this.state;

        const loginProvider = currentHealthPlanInfo && currentHealthPlanInfo.LoginProvider ? currentHealthPlanInfo.LoginProvider.toLowerCase() : '';
        const logoUrl = currentHealthPlanInfo && currentHealthPlanInfo.LogoURL;
        this.currentUserRole = loginProvider === LOGIN_PROVIDER_AUTO_FIRSTCARE ? "FC" : loginProvider === LOGIN_PROVIDER_AUTO_AAL ? "AA" :
            (loginProvider === LOGIN_PROVIDER_AUTO_HR_SWHP || loginProvider === LOGIN_PROVIDER_AUTO_SWHP) ? "SWHP" : '';
        const planName = currentHealthPlanInfo && currentHealthPlanInfo.FullName ? currentHealthPlanInfo.FullName : this.getHealthPlanName(this.currentUserRole);

        if (!isAutoLinking && linkAutoError) {//just removed the userrole as we need to show the error page for all the autolinking.
            this.props.clearMessage();
            this.props.hideAutoHPLinkModal(false);
            if (this.currentUserRole === "AA") {
                this.props.history.push("/hplinkingerror");
            } else {
                this.props.history.push({
                    pathname: '/hplinkingerror',
                    state: {
                        callTo: 'MyBSWHealth technical help desk ', at: this.props.technicalHelpDeskNumber, hdHours: this.props.technicalHelpDeskHours
                    }
                });
            }
        }

        let displayName = '';
        if (primaryUser) {
            displayName = getFirstName(primaryUser.displayName);
        }

        const data =
        {
            alt: `${planName} logo`, src: logoUrl,
            heading: `We found your ${planName} account!`
        };

        return (
            <Modal className="link-potentialAA-modal" isOpen={showModal} toggle={() => this.toggleModal(false)} centered backdrop="static" keyboard={false}>
                <ModalBody>
                    <div className={`row aa-link-modal`}>
                        {(!linkLater || linkAutoSuccess) && data && <img alt={data.alt} className="aa-logo-modal" src={data.src} />}
                        {!linkAutoSuccess && !linkLater && data &&
                            <div className="col-12">
                                <p className="heading">{data.heading}</p>
                                <p>Link your health plan to access claims, deductibles, ID Cards, plan benefits, and more through MyBSWHealth.</p>
                            </div>
                        }

                        {linkAutoSuccess &&
                            <div className="col-12 aa-link-success">
                                <div><span className="icon-list-check" /></div>
                                <h3>Thanks, you're all set!</h3>
                                <p>We've successfully linked your account.</p>
                                <button className="btn btn-primary okay-btn" onClick={() => this.toggleModal(false)}>OKAY</button>
                            </div>

                        }

                        {!linkAutoSuccess && linkLater &&
                            <React.Fragment>
                                <div className="col-12 aa-link-later">
                                    <span className="icon-settings" />
                                </div>
                                <div className="col-12">
                                    <p className="heading">By opting out, these features will not be available in MyBSWHealth:</p>
                                    <p className="heading">Access to health plan claims, deductibles, ID Cards, plan benefits and more.</p>
                                    <p className="heading">Are you sure you want to opt out?</p>
                                </div>
                                <div className="col-12 opt-buttons">
                                    <div className="row">
                                        <div className="col-12 col-sm-6 text-right">
                                            <button className="btn btn-primary" onClick={() => this.toggleModal(true)}>YES, OPT OUT</button>
                                        </div>
                                        <div className="col-12 col-sm-6 text-left">
                                            <button className="btn btn-primary" onClick={() => this.onLinkAccount('yes')}>NO, LET'S LINK IT</button>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        }
                    </div>
                </ModalBody>
                <ModalFooter>
                    {!linkAutoSuccess && !linkLater ? <div className="row">
                        <div className="col-12">
                            <div className="footer-buttons">
                                <button className="btn btn-primary" onClick={() => this.onLinkAccount('yes')} >LINK IT</button>
                                <div><button className="btn text-btn" onClick={() => this.onLinkAccount('no')}>Opt Out</button></div>
                            </div>
                        </div>
                    </div>
                        : null}
                    {!linkAutoSuccess && linkLater &&
                        <div className="col-12">
                            <p className="disclaimer">You can link this account later by going to Linked Accounts and Devices under Settings.</p>
                        </div>
                    }
                </ModalFooter>
                {isAutoLinking && <MiniSpinner />}
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        showModal: state.session.showAutoHPLinkModal,
        technicalHelpDeskNumber: state.session.serverData.technicalHelpDeskNumber,
        technicalHelpDeskHours: state.session.serverData.technicalHelpDeskHours,
        userName: state.domain.un,
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        linkAutoError: state.healthPlan.linkAutoHPError,
        isAutoLinking: state.healthPlan.isAutoHPLinking,
        linkAutoSuccess: state.healthPlan.linkAutoHPSuccess,
        history: state.session.history,
        currentHealthPlanInfo: state.session.currentHealthPlanInfo
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        linkAutoAccount: (loginProvider, providerKey, userRole) => dispatch({
            type: types.LINK_AUTO_HP_ACCOUNT_START, payload: { loginProvider, providerKey, userRole }
        }),
        hideAutoHPLinkModal: (flag) => {
            dispatch({ type: types.SET_HIDE_AUTO_HP_LINKMODAL, showAutoHPLinkModal: flag });
        },
        clearMessage: () => dispatch({
            type: types.LINK_AUTO_HP_ACCOUNT_CLEAR_MESSAGE
        })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AutoLinkModalForHP);